import { Localization } from "../../../OW.Remoting/Remoting/Localization";
import { BasicValidationLocalizer } from "../../UI.ElementarControls/Helpers/BasicValidationLocalizer";
/**
* Třída natahuje validační hlášky z lokalizační databáze přes remoting
*/
export class RemotingValidationLocalizer extends BasicValidationLocalizer {
    private static _initialized = false;

    constructor() {
        super();

        if (!RemotingValidationLocalizer._initialized) {
            RemotingValidationLocalizer._initialized = true;
            this._loadAllLocalizations();
        }
    }

    /**
     * Načte ze serveru všechny lokalizační hlášky uvedené v kolekci _locs a získanou hodnotu do této kolekce zpátky uloží
     */
    private async _loadAllLocalizations(): Promise<void> {
        const promises = new Array<Promise<void>>();

        this._locs.forEach((_val, code) => {
            promises.push(Localization.getTextPromise(code).then((text) => {
                if (text == null || text === "") // pro případ, že by v db nebyla potřebná lokalizace pro klíč
                    text = `Invalid (${code})`; //`

                this._locs.set(code, text);
            }));
        });

        await Promise.all(promises);
    }
}
